import React from 'react';
import LoadBetButton from './LoadBetButton';
import ReloadTicketButton from './ReloadTicketButton';

export default function ReloadTicketSection(props) {
    const ticket = props.ticket;

    return (
        <>
            {(props.isCheckbet && !window.appConfig?.XSHOP_TERMINAL) ?
                <LoadBetButton ticketId={ticket.id} />
                :
                <ReloadTicketButton id={ticket.id} />
            }
        </>
    );
}
